var map = {
	"./tick-delivered.svg": "845c",
	"./tick-failed.svg": "726d",
	"./tick-queued.svg": "ea7d",
	"./tick-read.svg": "5ae7",
	"./tick-sent.svg": "66ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "004d";